import React from "react";
import Input from "components/foundation/Input/Input";
import CreateDocumentFormField from ".";
import CommentTextArea from "components/foundation/TextArea/CommentTextArea";

interface ApproverCommentFieldProps {
  comment: string;
  noBorder?: boolean;
}

const ApproverCommentField = ({
  comment,
  noBorder,
}: ApproverCommentFieldProps) => {
  return (
    <CreateDocumentFormField label="결재자 코멘트">
      <Input className="pc-only" readOnly value={comment} noBorder={noBorder} />
      <CommentTextArea
        className="mobile-only"
        fill
        readOnly
        text={comment}
        noBorder={noBorder}
      />
    </CreateDocumentFormField>
  );
};

export default ApproverCommentField;
